import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFiatComponent } from './simple-icons-fiat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFiatComponent ],
    exports:      [ SimpleIconsFiatComponent ],
    bootstrap:    []
})
export class SimpleIconsFiatModule {}
